import Vue from 'vue'
const Bus = new Vue()

export default Bus
// updateFloor事件: 楼层排序之后触发，用于加载图片

// slideShow事件：轮播图片展示上报

// screenModeChange事件：宽窄屏切换
